
module.exports = file => () => import('@/views/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/router/_import_production.js